import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppSwitcher as AppSwitcherIcon } from '@fluentsms/agentnet-web-icons';
import { AppBar, IconButton, makeStyles, Toolbar, Tooltip } from '@material-ui/core';
import { useState } from 'react';
import { appHeaderHeight } from '../../theme';
import { AppSwitcher } from '../AppSwitcher';
const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: theme.palette.brand.legacy,
    },
    appSwitcherIcon: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 0,
        height: 64,
        marginRight: theme.spacing(2),
        padding: 0,
        width: 64,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
        '& span, & svg': {
            pointerEvents: 'none',
        },
    },
    toolbar: {
        minHeight: appHeaderHeight,
        padding: theme.spacing(0, 3, 0, 0),
    },
}));
/**
 * Branded component for the application header.
 *
 * @param {React.ReactElement} props.appBar  Optional `AppBar` component that renders the logo, right and
 * optional center content.
 * @param {NavigationLink[]} props.links - The links to be rendered in the `AppSwitcher` component.
 * @returns {JSX.Element} The rendered `AppHeader` component.
 */
export function AppHeader({ appBar, links }) {
    const classes = useStyles();
    const [isAppSwitcherVisible, setIsAppSwitcherVisible] = useState(false);
    const handleAppSwitcherClick = () => {
        setIsAppSwitcherVisible(!isAppSwitcherVisible);
    };
    return (_jsx(AppBar, { elevation: 0, className: classes.appBar, position: 'sticky', children: _jsxs(Toolbar, { disableGutters: true, className: classes.toolbar, children: [_jsx(Tooltip, { arrow: true, placement: 'bottom', title: 'Applications and Services', children: _jsx(IconButton, { className: classes.appSwitcherIcon, color: 'primary', "data-testid": 'appswitcher-button', disableFocusRipple: true, disableTouchRipple: true, disableRipple: true, onClick: handleAppSwitcherClick, children: _jsx(AppSwitcherIcon, { height: 24, width: 24 }) }) }), _jsx(AppSwitcher, { links: links, visible: isAppSwitcherVisible, setVisible: setIsAppSwitcherVisible }), appBar && appBar] }) }));
}
